import { connect } from 'react-redux';
import TambahDataMapel from '../../views/Settings/TambahDataMapel.view';
import { getClasses, getParamOptionsAcademics, getTeacherOptions, getSchoolUnitsOptions, getParamPerwakilan,
  getSubjectOptions, getParamOptions, getDayOptions, getClassesOptions,getPeriodsOptions, getPrmLevels } from '../../states/thunks/options.thunk';
import { getScheduleSubject, updateMasterMapel, saveMapelUnits, listMapelActive, getMapelUnits,getAddAttendanceStudyField } from '../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  }
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleSaveMapelUnits: (payload, goback) => dispatch(saveMapelUnits(payload, goback)),
    handleListMapelActive: (payload, goback) => dispatch(listMapelActive(payload, goback)),
    handleUpdatetMasterMapel: (payload, goback) => dispatch(updateMasterMapel(payload, goback)),
    handleGetScheduleSubject: payload => dispatch(getScheduleSubject(payload)), 
    getSubjectOptions: (payload) => dispatch(getSubjectOptions(payload)),
    getTeacherOptions: (payload) => dispatch(getTeacherOptions(payload)),
    getDayOptions: (payload) => dispatch(getDayOptions(payload)),
    getClassesOptions: (payload) => dispatch(getClassesOptions(payload)),
    getPrmLevels: (payload) => dispatch(getPrmLevels(payload)),
    getPeriodsOptions: (payload) => dispatch(getPeriodsOptions(payload)),
    getSchoolUnitsOptions: (payload) => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: (payload) => dispatch(getParamPerwakilan(payload)),
    handleGetMapelUnits: payload => dispatch(getMapelUnits(payload)),
    handleGetAddAttendanceStudyField: payload => dispatch(getAddAttendanceStudyField(payload)),

  };

}

export default connect(mapStateToProps, mapDispatchToProps)(TambahDataMapel);
